import qs from 'query-string';
import { deleteRequest, getRequest, patchRequest, postRequest } from 'services/requests';

const services = {
    createCourse: (id, body) => postRequest(`/courses/${id}`, body),
    findCourse: (id) => getRequest(`/courses/${id}`),
    listCourses: () => getRequest(`/courses`),
    updateCourse: (id, body) => patchRequest(`/courses/${id}`, body),
    deleteCourse: (id, body) => deleteRequest(`/courses/${id}`, body),
    listCourseAccounts: (id) => getRequest(`/courses/${id}/accounts`),
    createCourseAssignment: (id, body) => postRequest(`/courses/${id}/assignments`, body),
    listCourseAssignments: (id, filter, orderBy, skip, top) => {
        const query = qs.stringify(
            { $filter: filter, $orderBy: orderBy, $skip: skip, $top: top },
            { skipNull: true, skipEmptyString: true }
        );
        return getRequest(`/courses/${id}/assignments${query && `?${query}`}`);
    },
    listCourseUsers: (id) => getRequest(`/courses/${id}/users`),
};

export default services;
